
<app-filter-results [filterBy]="filterBy" [isFilterCalendar]="true"[isFilterServices]="true" [isFilterClients]="true"[isFilterCaseManagers]="true" [isFilterInAvailable]="true"
[searchBy]="searchBy" [isSearchingAvailable]="true" (onApplyFilter)="applyFilter($event)"
(resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)"></app-filter-results>